import store from '@/store'

/**
 * Detects if the user is in Israel based on user data or timezone
 * @returns {boolean} true if the user appears to be in Israel
 */
export function detectIsrael(userCountry) {
  if (userCountry) {
    return userCountry === 'IL'
  }

  return detectByTimezone()
}

/**
 * Detects Israel based on browser timezone
 * @returns {boolean} true if timezone indicates Israel
 */
function detectByTimezone() {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const israelTimeZones = [
    'Asia/Jerusalem',
    'Asia/Tel_Aviv',
    'Israel',
    'Jerusalem',
  ]

  return israelTimeZones.includes(timeZone)
}
